import styled from "styled-components";

export const OtpInputContainer = styled.div`
  .otp-label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.card.font.tertiary};
    margin-bottom: 8px;
    font-family: "Geist", sans-serif;
  }

  .otp-boxes {
    display: flex;
    gap: 8px;
    margin: 12px 0;
  }

  .otp-box {
    width: 44px;
    height: 44px;
    padding: 0;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    font-family: "Geist", sans-serif;
    /* Inherited on purpose: the modal sets a theme-aware body colour, while
       the signup screen it also renders on is hardcoded light. */
    color: inherit;
    background: transparent;
    /* Same neutral the signup boxes shipped with: theme.input.border.color is
       near-black in dark mode, which disappears against a dark modal. */
    border: 1px solid #d5d7da;
    border-radius: 8px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
      border-color: #0a7eff;
      box-shadow: 0 0 0 3px rgba(10, 126, 255, 0.1);
      outline: none;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &.is-invalid {
      border-color: #dc3545;
    }
  }

  .form-error {
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 1.4;
  }

  @media (max-width: 768px) {
    .otp-boxes {
      gap: 6px;
    }

    .otp-box {
      width: 40px;
      height: 40px;
      font-size: 16px;
    }
  }
`;
